import React from 'react';
// components
import DropdownSearch from './dropdown_search';

class Searchbar extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            typed: false,
            clicked: false,
            query: ""
        }
    }
    handleClick () {
        this.setState({
            clicked: true
        })
    }
    handleTyping (e) {
        var q = e.target.value
        // if typed and string is not empty
        this.setState({
            typed: e.target.value != "",
            query: e.target.value
        })
    }
    clearTypeStatus () {
        this.setState({typed: false, clicked: false})
    }
    clearClickStatus () {
        this.setState({typed: false, clicked: false})
    }
    render() {
        return (
            <form className="form-inline my-2 my-lg-0">
                <input className="form-control mr-sm-2" type="search" 
                    placeholder="Search" aria-label="Search"
                    value={this.state.query}
                    onClick={this.handleClick.bind(this)}
                    onChange={this.handleTyping.bind(this)}/>
                <button className="btn btn-outline-success my-2 my-sm-0" type="submit" >Search</button>
                <DropdownSearch 
                    typed={this.state.typed} 
                    clicked={this.state.clicked}
                    clearClickStatus={this.clearClickStatus.bind(this)}
                    clearTypeStatus={this.clearTypeStatus.bind(this)}/>
            </form>
        )
    }
}

export default Searchbar